import { BASE, getToken } from '@/lib/api';

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function fmtNumber(value: number) {
  return new Intl.NumberFormat('en-SG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function buildSoaRoute(params: {
  view: 'ar' | 'ap' | 'combined';
  partyId: string;
  partyName?: string;
  from: string;
  to: string;
  autostart?: boolean;
}) {
  const query = new URLSearchParams({
    view: params.view,
    partyId: params.partyId,
    from: params.from,
    to: params.to,
  });
  if (params.partyName) query.set('partyName', params.partyName);
  if (params.autostart) query.set('autostart', '1');
  return `/finance/reports/soa?${query.toString()}`;
}

export function hasResolvableSoaPartyRef(value: string | null | undefined) {
  const normalized = String(value ?? '').trim().toLowerCase();
  return normalized !== ''
    && normalized !== 'unknown'
    && normalized !== 'n/a'
    && normalized !== 'na'
    && normalized !== 'null'
    && normalized !== 'undefined';
}

function getFileNameFromDisposition(contentDisposition: string | null, fallbackFileName: string) {
  if (!contentDisposition) return fallbackFileName;
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1]);
  const plainMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  if (plainMatch?.[1]) return plainMatch[1];
  return fallbackFileName;
}

export async function downloadAuthenticatedFile(path: string, fallbackFileName: string) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!res.ok) {
    const message = await res.text().catch(() => 'Download failed');
    throw new Error(message || 'Download failed');
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = getFileNameFromDisposition(res.headers.get('content-disposition'), fallbackFileName);
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);

  return {
    fileName: anchor.download,
    contentType: res.headers.get('content-type') ?? blob.type,
  };
}

export async function downloadAuthenticatedCsv(path: string, fileName: string) {
  await downloadAuthenticatedFile(path, fileName);
}